import React from 'react';
import { toast, ToastContainer } from 'react-toastify';

const Help = () => {
    const helpSections = [
        {
            title: 'Getting Started',
            items: [
                { name: 'Dashboard Overview', description: 'Learn about the main dashboard and key metrics' },
                { name: 'User Management', description: 'How to manage users, roles, and permissions' },
                { name: 'Client Management', description: 'Managing client accounts and settings' },
                { name: 'Carrier Setup', description: 'Setting up carriers and voice/SMS accounts' }
            ]
        },
        {
            title: 'System Administration',
            items: [
                { name: 'Access Management', description: 'Managing access groups, areas, and rights' },
                { name: 'System Settings', description: 'Configuring system-wide settings and preferences' },
                { name: 'Reports & Analytics', description: 'Understanding reports and data analytics' },
                { name: 'Billing & Invoices', description: 'Managing billing, payments, and invoices' }
            ]
        },
        {
            title: 'Product Management',
            items: [
                { name: 'Rate Management', description: 'Setting up and managing voice and SMS rates' },
                { name: 'Number Management', description: 'Managing phone numbers and DID assignments' },
                { name: 'Product Configuration', description: 'Configuring products and services' },
                { name: 'Master Codes', description: 'Managing SMS master codes and prefixes' }
            ]
        },
        {
            title: 'Troubleshooting',
            items: [
                { name: 'Common Issues', description: 'Solutions to frequently encountered problems' },
                { name: 'Error Messages', description: 'Understanding system error messages' },
                { name: 'Performance Issues', description: 'Troubleshooting system performance problems' },
                { name: 'Integration Problems', description: 'Resolving API and integration issues' }
            ]
        },
        {
            title: 'Support & Contact',
            items: [
                { name: 'Contact Support', description: 'How to reach our technical support team' },
                { name: 'Feature Requests', description: 'Requesting new features or improvements' },
                { name: 'Documentation', description: 'Access to detailed system documentation' },
                { name: 'Training Resources', description: 'Training materials and tutorials' }
            ]
        }
    ];

    const handleContactSupport = () => {
        toast.info('Support contact information will be displayed here');
    };

    const handleFeatureRequest = () => {
        toast.info('Feature request form will be displayed here');
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                    <div className="page-header">
                        <h1>Help & Support</h1>
                        <p className="text-muted">Find answers to your questions and get the support you need</p>
                    </div>
                </div>
            </div>

            <div className="row">
                {/* Welcome Section */}
                <div className="col-md-12">
                    <div className="panel panel-primary">
                        <div className="panel-heading">
                            <h3 className="panel-title">
                                <i className="icon-question-circle"></i> Welcome to Help & Support
                            </h3>
                        </div>
                        <div className="panel-body">
                            <div className="row">
                                <div className="col-md-8">
                                    <h4>How can we help you today?</h4>
                                    <p>
                                        Welcome to the Saara platform help and support center. Here you'll find comprehensive 
                                        documentation, troubleshooting guides, and resources to help you make the most of 
                                        our system.
                                    </p>
                                    <p>
                                        Whether you're a new user getting started or an experienced administrator looking 
                                        for advanced features, we're here to help you succeed.
                                    </p>
                                </div>
                                <div className="col-md-4">
                                    <div className="well">
                                        <h5><i className="icon-lightbulb"></i> Quick Tips</h5>
                                        <ul className="list-unstyled">
                                            <li><i className="icon-check text-success"></i> Use the search function to find specific topics</li>
                                            <li><i className="icon-check text-success"></i> Check the troubleshooting section for common issues</li>
                                            <li><i className="icon-check text-success"></i> Contact support for urgent technical problems</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Help Index */}
            <div className="row">
                <div className="col-md-12">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title">
                                <i className="icon-book"></i> Help Index
                            </h3>
                        </div>
                        <div className="panel-body">
                            {helpSections.map((section, sectionIndex) => (
                                <div key={sectionIndex} className="help-section" style={{ marginBottom: '30px' }}>
                                    <h4 style={{ 
                                        color: '#337ab7', 
                                        borderBottom: '2px solid #337ab7', 
                                        paddingBottom: '5px',
                                        marginBottom: '15px'
                                    }}>
                                        <i className="icon-folder"></i> {section.title}
                                    </h4>
                                    <div className="row">
                                        {section.items.map((item, itemIndex) => (
                                            <div key={itemIndex} className="col-md-6" style={{ marginBottom: '15px' }}>
                                                <div className="help-item" style={{
                                                    padding: '15px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '5px',
                                                    backgroundColor: '#f9f9f9',
                                                    height: '100%',
                                                    transition: 'all 0.3s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.backgroundColor = '#f0f0f0';
                                                    e.target.style.borderColor = '#337ab7';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.backgroundColor = '#f9f9f9';
                                                    e.target.style.borderColor = '#ddd';
                                                }}>
                                                    <h5 style={{ 
                                                        marginTop: '0', 
                                                        color: '#333',
                                                        fontSize: '16px'
                                                    }}>
                                                        <i className="icon-file-text"></i> {item.name}
                                                    </h5>
                                                    <p style={{ 
                                                        marginBottom: '10px', 
                                                        color: '#666',
                                                        fontSize: '14px'
                                                    }}>
                                                        {item.description}
                                                    </p>
                                                    <button 
                                                        className="btn btn-sm btn-primary"
                                                        onClick={() => toast.info(`Help content for "${item.name}" will be displayed here`)}
                                                    >
                                                        <i className="icon-search"></i> Learn More
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Quick Actions */}
            <div className="row">
                <div className="col-md-12">
                    <div className="panel panel-info">
                        <div className="panel-heading">
                            <h3 className="panel-title">
                                <i className="icon-cogs"></i> Quick Actions
                            </h3>
                        </div>
                        <div className="panel-body">
                            <div className="row">
                                <div className="col-md-3">
                                    <button 
                                        className="btn btn-info btn-block" 
                                        style={{ marginBottom: '10px' }}
                                        onClick={handleContactSupport}
                                    >
                                        <i className="icon-phone"></i> Contact Support
                                    </button>
                                </div>
                                <div className="col-md-3">
                                    <button 
                                        className="btn btn-success btn-block" 
                                        style={{ marginBottom: '10px' }}
                                        onClick={handleFeatureRequest}
                                    >
                                        <i className="icon-plus"></i> Request Feature
                                    </button>
                                </div>
                                <div className="col-md-3">
                                    <button 
                                        className="btn btn-warning btn-block" 
                                        style={{ marginBottom: '10px' }}
                                        onClick={() => toast.info('System status information will be displayed here')}
                                    >
                                        <i className="icon-signal"></i> System Status
                                    </button>
                                </div>
                                <div className="col-md-3">
                                    <button 
                                        className="btn btn-primary btn-block" 
                                        style={{ marginBottom: '10px' }}
                                        onClick={() => toast.info('Documentation portal will be opened')}
                                    >
                                        <i className="icon-external-link"></i> Documentation
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
        </div>
    );
};

export default Help; 